import {memo} from 'react';
import clsx from 'clsx';
import styles from './TimeSlot.module.css';
import {Inline, Text} from '@treatwell/ui';
import {TimeSlotItem} from '../TimeSlotList/TimeSlotList';
import {isAvailabiltyRoute} from '../../utils/isRoute';

export type Props = TimeSlotItem & {
  isSelected: boolean;
  selectedDate: string;
};

export const TimeSlot = memo(
  ({
    startTime,
    salePriceAmount,
    fullPriceAmount,
    isSelected,
    selectedDate,
  }: Props) => {
    const isAvailability = isAvailabiltyRoute();
    const styleClasses = clsx(styles.timeSlot, {
      [styles.timeSelected]: isSelected,
      [styles.timeSelectedBgColor]: isSelected,
      [styles.oneTap]: isAvailability,
    });

    const dotClasses = clsx(styles.dot, {
      [styles.hideDot]: !isSelected,
    });

    const isPriceDiscounted = salePriceAmount !== fullPriceAmount;
    return (
      <button className={styleClasses}>
        <Inline justify="between">
          <Inline space="sm" className={styles.timeSelected}>
            <div className={dotClasses} />
            {isSelected ? (
              <Text
                as="time"
                dateTime={selectedDate}
                data-cy="SelectedStartTime"
                type="bodyHeavy"
                aria-label={`${startTime} ${selectedDate}`}
              >
                {startTime}
              </Text>
            ) : (
              <Text as="time" type="body" className={styles.time}>
                {startTime}
              </Text>
            )}
          </Inline>

          <div>
            {isPriceDiscounted && (
              <Text as="s" type="body" className={styles.originalPrice}>
                {fullPriceAmount}
              </Text>
            )}
            <Text
              as="p"
              type="bodyHeavy"
              className={
                isPriceDiscounted ? styles.discountedPrice : styles.price
              }
            >
              {isPriceDiscounted ? salePriceAmount : fullPriceAmount}
            </Text>
          </div>
        </Inline>
      </button>
    );
  },
);
